import axios from 'axios'
import { useToast } from '@chakra-ui/react'
import { useQuery } from 'react-query'
import { useState } from 'react'

const fetchReferenciasLayout = async (codigo_produto) => {
  if (!codigo_produto) return []

  const response = await axios.get('https://api.innovationbrindes.com.br/api/site/v2/fluxo-layout/consultar-layouts-referencia', {
    params: { codigo_produto },
  })

  return response.data
}

export function useConsultarReferenciaLayout() {
  const toast = useToast()
  const [codigoProduto, setCodigoProduto] = useState('')

  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery(['referenciasLayout', codigoProduto], () => fetchReferenciasLayout(codigoProduto), {
    enabled: !!codigoProduto, // Só executa a query quando houver um código de produto
    onSuccess: (data) => {
      if (data.length === 0) {
        toast({
          title: 'Nenhuma referência encontrada',
          description: 'Não foram encontradas referências para o código de produto informado',
          status: 'info',
          duration: 3000,
          isClosable: true,
        })
      }
    },
    onError: (error) => {
      console.error('Erro ao consultar referências:', error)
      toast({
        title: 'Erro na consulta',
        description: error.response?.data?.message || 'Ocorreu um erro ao consultar as referências',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
    retry: 1,
    staleTime: 1000 * 60 * 5, // Dados ficam "frescos" por 5 minutos
  })

  const consultarReferencias = (codigo_produto) => {
    setCodigoProduto(codigo_produto)
  }

  return {
    dados: data,
    loading: isLoading,
    error: isError ? error : null,
    consultarReferencias,
  }
}
